import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCategoryDocument } from '../../../api/axios';

const CategoriesContext = createContext();

export const useCategories = () => {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoriesProvider');
  }
  return context;
};

export const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getCategoryDocument();
        setCategories(response.data.data || []);
        setError(null);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const value = {
    categories,
    loading,
    error,
    refreshCategories: async () => {
      try {
        setLoading(true);
        const response = await getCategoryDocument();
        setCategories(response.data.data || []);
        setError(null);
      } catch (error) {
        console.error('Error refreshing categories:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
}; 